export default {"src":"/_next/static/media/edge.2c55ee41.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};